import React, { FC, ReactElement } from 'react'

// Lucide-react `History` icon, inlined so it matches the akixi-frontend toggle pixel-for-pixel.
// https://lucide.dev/icons/history (ISC licensed).

type Props = {
    size?: number
}

const HistoryIcon: FC<Props> = ({ size = 16 }: Props): ReactElement => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden='true'
    >
        <path d='M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
        <path d='M3 3v5h5' />
        <path d='M12 7v5l4 2' />
    </svg>
)

export default HistoryIcon
